import { useState } from "react";

import { IgButton } from "@intelligems/ig-theme";
import { Box, Stack } from "@mui/material";

export interface TabbedNavigationProps {
  tabs: string[];
  onTabChange: (tabName: string) => void;
  defaultTab?: string;
  buttonSize?: "extraSmall" | "small" | "medium" | "large";
  buttonSx?: React.ComponentProps<typeof IgButton>["sx"];
}

export const TabbedNavigation = ({
  tabs,
  onTabChange,
  defaultTab,
  buttonSize = "extraSmall",
  buttonSx,
}: TabbedNavigationProps) => {
  const [activeTab, setActiveTab] = useState<string>(
    defaultTab ?? tabs[0] ?? ""
  );

  const handleTabClick = (tabName: string) => {
    if (tabName === activeTab) {
      return;
    }
    setActiveTab(tabName);
    onTabChange(tabName);
  };

  if (tabs.length < 1) {
    return null;
  }

  return (
    <Box sx={{ position: "relative" }}>
      <Stack
        direction="row"
        spacing={1}
        sx={{
          overflowX: "auto",
          "&::-webkit-scrollbar": { display: "none" },
          scrollbarWidth: "none",
          paddingRight: 15,
        }}
      >
        {tabs.map((tab) => (
          <IgButton
            key={tab}
            variant={activeTab === tab ? "contained" : "outlined"}
            onClick={() => handleTabClick(tab)}
            sx={{ flexShrink: 0, ...buttonSx }}
            size={buttonSize}
          >
            {tab}
          </IgButton>
        ))}
      </Stack>
      <Box
        sx={{
          position: "absolute",
          right: 0,
          top: 0,
          bottom: 0,
          width: 40,
          background: "linear-gradient(to right, transparent, white)",
          pointerEvents: "none",
        }}
      />
    </Box>
  );
};
